import styled from 'styled-components';

const FormDescription = styled.div`
margin-top: 1rem;
`;

export default FormDescription;
